import { Component } from '@angular/core';
import { Feature } from '@freelancer/feature-flags';
import { ButtonColor } from '@freelancer/ui/button';

@Component({
  selector: 'app-navigation-secondary-help',
  template: `
    <app-bar flTrackingSection="SubnavHelp">
      <app-bar-item
        link="/support/categories"
        i18n="Secondary navigation help bar item"
        flTrackingLabel="GetSupport"
      >
        Get Support
      </app-bar-item>
      <app-bar-item
        *flFeature="Feature.HOW_IT_WORKS_PAGE"
        link="/info/how-it-works/"
        i18n="Secondary navigation help bar item"
        flTrackingLabel="HowItWorks"
        [exactLink]="true"
      >
        How Freelancer.com Works
      </app-bar-item>
      <app-bar-item
        link="/faq/view.php"
        i18n="Secondary navigation help bar item"
        flTrackingLabel="FAQ"
        [exactLink]="true"
      >
        Frequently Asked Questions
      </app-bar-item>
      <app-bar-item
        link="/feesandcharges"
        i18n="Secondary navigation help bar item"
        flTrackingLabel="FeesAndCharges"
        [exactLink]="true"
      >
        Fees and Charges
      </app-bar-item>
      <app-bar-item
        link="/dispute/disputeslist.php"
        i18n="Secondary navigation help bar item"
        flTrackingLabel="Disputes"
        [exactLink]="true"
      >
        Disputes
      </app-bar-item>
    </app-bar>
  `,
})
export class NavigationSecondaryHelpComponent {
  ButtonColor = ButtonColor;
  Feature = Feature;
}
